<template>
  <div>
    <info-transacao-pix
      :pedido="currentPedido"
      :integrar="integrarPedido"
      :estornar="estornarPedido"
      :close="closeInfo"
    />
    <Loading :isActive="loading"></Loading>
    <CTabs variant="tabs" class="nav-tabs-boxed">
      <CTab title="Acompanhamento PIX">
        <div class="xrow" style="margin-bottom: 10px">
          <div class="col-1-4">
            <label>De</label>
            <datetime
              input-class="form-control"
              v-model="dataInicio"
              type="date"
              :max-datetime="fim"
              placeholder="Data inicial"
              :phrases="{ ok: 'Confirmar', cancel: 'Fechar' }"
              value-zone="local"
              format="dd/MM/yyyy"
            />
          </div>
          <div class="col-1-4">
            <label>Até</label>
            <datetime
              input-class="form-control"
              v-model="dataFim"
              type="date"
              :min-datetime="inicio"
              placeholder="Data final"
              :phrases="{ ok: 'Confirmar', cancel: 'Fechar' }"
              value-zone="local"
              format="dd/MM/yyyy"
            />
          </div>
          <div class="col-1-4">
            <label>Origem</label>
            <select class="form-control" v-model="origem">
              <option value="">Todas</option>
              <option v-for="o in origens" :key="o.value" :value="o.value">
                {{ o.label }}
              </option>
            </select>
          </div>
          <div class="col-1-4">
            <label>Pedido ou cliente</label>
            <input
              type="text"
              class="form-control"
              v-model="busca"
              placeholder="Número do pedido, nome ou documento"
              v-on:keyup.enter="() => loadPedidos()"
            />
          </div>
          <div class="col-1-4">
            <label>&nbsp;</label><br />
            <button class="button button-primary" v-on:click="() => loadPedidos()">
              <fa-icon icon="search" /> Buscar
            </button>
          </div>
        </div>

        <!--
          O status sai do <select> e vira chip: era o único filtro cujo valor
          ativo não aparecia na tela, e a contagem por chip mostra de uma vez o
          que existe fora do recorte selecionado.
        -->
        <status-filter-bar
          v-model="status"
          :chips="statusChips"
          :contagens="contagens"
        />

        <lista-transacoes-pix
          :pedidos="pedidos"
          :carregando="carregandoLista"
          :erro="erroLista"
          :openInfo="openInfo"
          :recarregar="() => loadPedidos()"
        />

        <div
          v-if="temResultado"
          style="display: flex; justify-content: center; margin-top: 16px"
        >
          <pagination
            :data="paginator"
            :limit="5"
            @pagination-change-page="loadPedidos"
          ></pagination>
        </div>
      </CTab>
    </CTabs>
  </div>
</template>

<script>
import moment from 'moment';
import { get, post } from '../../helpers/apiRequest';
import ListaTransacoesPix from './ListaTransacoesPix';
import InfoTransacaoPix from './InfoTransacaoPix';
import StatusFilterBar from '../../components/StatusFilterBar';

export default {
  name: 'pix-acompanhamento',
  components: {
    ListaTransacoesPix,
    InfoTransacaoPix,
    StatusFilterBar,
  },
  data() {
    return {
      loading: false,
      carregandoLista: true,
      erroLista: null,
      pedidos: [],
      contagens: {},
      paginator: {},
      currentPedido: {},
      dataInicio: moment()
        .subtract(7, 'days')
        .format('YYYY-MM-DD'),
      dataFim: moment().format('YYYY-MM-DD'),
      origem: '',
      busca: '',
      status: 'PAGOS',
      origens: [
        { value: 'CALLCENTER', label: 'CallCenter' },
        { value: 'FORCA_VENDAS', label: 'Força de Vendas' },
        { value: 'B2B', label: 'B2B' },
        { value: 'B2B_APP', label: 'B2B App' },
      ],
      /**
       * As cores repetem as dos badges da listagem de propósito: o chip e a
       * linha que ele filtra têm de ser reconhecíveis como a mesma coisa.
       */
      statusOptions: [
        { value: 'PAGOS', label: 'Pagos', cor: '#2eb85c' },
        { value: 'NAO_INTEGRADOS', label: 'Pagos não integrados', cor: '#f9b115' },
        { value: 'AGUARDANDO_INTEGRACAO', label: 'Aguardando integração', cor: '#5996b4' },
        { value: 'COM_FALHA', label: 'Com falha', cor: '#e55353' },
        { value: 'DEVOLVIDOS', label: 'Devolvidos', cor: '#6c757d' },
        { value: 'TODOS', label: 'Todos' },
      ],
    };
  },

  computed: {
    inicio() {
      return this.dataInicio
        ? moment(this.dataInicio).format('YYYY-MM-DD')
        : '';
    },
    fim() {
      return this.dataFim ? moment(this.dataFim).format('YYYY-MM-DD') : '';
    },
    statusChips() {
      return this.statusOptions.map((s) => ({
        chave: s.value,
        label: s.label,
        cor: s.cor,
        dot: !!s.cor,
      }));
    },
    temResultado() {
      return !this.carregandoLista && !this.erroLista && this.pedidos.length > 0;
    },
  },

  watch: {
    /**
     * Trocar o chip busca na hora: um filtro que exige clicar em Buscar depois
     * de selecionado se comporta como o <select> que ele substituiu.
     */
    status() {
      this.loadPedidos();
    },
  },

  methods: {
    loadPedidos(page = 1) {
      this.carregandoLista = true;
      this.erroLista = null;

      const params = new URLSearchParams({
        page,
        take: 15,
        status: this.status,
      });

      if (this.inicio) {
        params.append('data_inicio', this.inicio);
      }
      if (this.fim) {
        params.append('data_fim', this.fim);
      }
      if (this.origem) {
        params.append('origem', this.origem);
      }
      if (this.busca && this.busca.trim()) {
        params.append('busca', this.busca.trim());
      }

      get(`/admin/pix-acompanhamento?${params.toString()}`)
        .then((json) => {
          this.pedidos = json.itens;
          this.paginator = json.paginator;
          this.contagens = json.contagens || {};
        })
        .catch((error) => {
          // A falha fica na área da lista, não num alerta: o operador precisa
          // ver que a fila não carregou e que nada foi alterado.
          this.pedidos = [];
          this.paginator = {};
          this.erroLista = error.message;
        })
        .finally(() => {
          this.carregandoLista = false;
        });
    },

    openInfo(pedido) {
      this.loading = true;
      get(`/admin/pix-acompanhamento/${pedido.id}`)
        .then((detalhe) => {
          this.currentPedido = detalhe;
          this.$modal.show('info-transacao-pix');
        })
        .finally(() => {
          this.loading = false;
        });
    },

    closeInfo() {
      this.loading = false;
      this.$modal.hide('info-transacao-pix');
    },

    integrarPedido(pedido) {
      const self = this;

      this.$swal({
        title: 'Integrar pedido?',
        text: 'O pedido será enviado ao ERP. O pagamento do cliente não é alterado.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Integrar',
        cancelButtonText: 'Cancelar',
      }).then((res) => {
        if (!res.value) {
          return;
        }

        this.loading = true;
        post(`/admin/pix-acompanhamento/${pedido.id}/integrar`)
          .then((response) => {
            this.closeInfo();
            this.showSuccess(response.message, function() {
              self.loadPedidos(self.paginator.current_page || 1);
            });
          })
          .catch((error) => {
            this.loading = false;
            // recarrega para a linha trazer a critica do ERP atualizada
            this.showError(this.mensagemComDetalhe(error), function() {
              self.loadPedidos(self.paginator.current_page || 1);
            });
          });
      });
    },

    /**
     * Devolve o pagamento ao cliente. É a única ação da tela que mexe em
     * dinheiro e não tem desfazer, então a confirmação mostra o valor e usa o
     * vermelho de `.button-error` — o mesmo do botão que abriu o diálogo.
     *
     * O valor é formatado por `$options.filters`, e não pelo pipe do template:
     * dentro de expressão JavaScript o `|` do Vue 2 é OR bitwise, que truncaria
     * o valor e procuraria uma propriedade `monetary`.
     */
    estornarPedido(pedido) {
      const self = this;
      const valor = this.$options.filters.monetary(pedido.valor);

      this.$swal({
        title: 'Estornar pagamento?',
        text: `O valor de ${valor} será devolvido ao cliente pela adquirente. Esta ação não pode ser desfeita.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Estornar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#dd514c',
      }).then((res) => {
        if (!res.value) {
          return;
        }

        this.loading = true;
        post(`/admin/pix-acompanhamento/${pedido.id}/estornar`)
          .then((response) => {
            this.closeInfo();
            this.showSuccess(response.message, function() {
              self.loadPedidos(self.paginator.current_page || 1);
            });
          })
          .catch((error) => {
            this.loading = false;
            // recarrega para a linha refletir a tentativa registrada
            this.showError(this.mensagemDoEstorno(error), function() {
              self.loadPedidos(self.paginator.current_page || 1);
            });
          });
      });
    },

    /**
     * Além do detalhe, o erro do estorno traz o status que a adquirente deu à
     * devolução — e é ele que diz ao operador o que fazer: `EM_PROCESSAMENTO`
     * pede esperar, `NAO_REALIZADO` permite tentar de novo. Sem isso as duas
     * situações leem igual.
     */
    mensagemDoEstorno(error) {
      const status = error.apiResponse && error.apiResponse.statusDevolucao;
      const mensagem = this.mensagemComDetalhe(error);

      return status ? `${mensagem} (devolução ${status})` : mensagem;
    },

    /**
     * A recusa do ERP vem em dois campos: a mensagem que explica o que houve e
     * o detalhe com a crítica crua da integradora. Sem o detalhe o operador lê
     * "o ERP recusou" e não fica sabendo o motivo.
     *
     * Concatenado em texto, e não em HTML: o detalhe vem do ERP e renderizá-lo
     * como markup abriria injeção no painel. O swal também não quebra linha em
     * `text`, então o separador é inline.
     */
    mensagemComDetalhe(error) {
      const detalhe = error.apiResponse && error.apiResponse.detalhe;

      return detalhe ? `${error.message} — ${detalhe}` : error.message;
    },

    showSuccess(message, callback) {
      this.$swal({
        title: 'Sucesso!',
        text: message,
        icon: 'success',
        confirmButtonText: 'Fechar',
      }).then(() => {
        callback ? callback() : null;
      });
    },

    showError(message, callback) {
      this.loading = false;
      this.$swal({
        title: 'Ops, algo deu errado!',
        text: message,
        icon: 'warning',
        confirmButtonText: 'Fechar',
      }).then(() => {
        callback ? callback() : null;
      });
    },
  },

  beforeMount() {
    this.loadPedidos();
  },
};
</script>
